// Preload critical images to prevent re-fetching on navigation
export const preloadImage = (src: string): void => {
  const img = new Image()
  img.src = src
}

export const preloadServiceImages = (): void => {
  const serviceImages = [
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/employee_led_improvement.webp',
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/organizational_change_alignment.webp',
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/leadership_development.webp',
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/experiential_knowledge_capture.webp',
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/rapid_capability_development.webp',
    'https://kesimages.sfo3.cdn.digitaloceanspaces.com/KES/digital_operational_excellence.webp',
  ]

  // Preload after a short delay to not block initial page load
  setTimeout(() => {
    serviceImages.forEach(preloadImage)
  }, 1000)
}
